import type { SportEvent } from '../../types/SportEventTypes';
import { participantMainId, readPayload } from '../shared';

/**
 * Participant fields that make a player "featured" in a given NHL event type.
 * Mirrors the roles the clip-creation drawer surfaced when this logic was
 * hardcoded in ClipCreationForm — now keyed off the canonical `id.main` join
 * key (was `id.smt`, which resolves identically for hockey but is absent from
 * the NBA wire format).
 */
const FEATURED_FIELDS_BY_TYPE: Record<string, ReadonlyArray<string>> = {
  goal: ['shooter', 'assister'],
  shootout_goal: ['shooter', 'assister'],
  shot_on_goal: ['shooter'],
  missed_shot: ['shooter'],
  blocked_shot: ['shooter'],
  giveaway: ['caused', 'committed'],
  hit: ['hitter', 'was_hit'],
  goalie_save: ['goalie'],
  penalty: ['committed'],
  pass: ['sender', 'receiver'],
  faceoff: ['possession'],
};

export function nhlFeaturedParticipantIds(event: SportEvent): string[] {
  const { type, data } = readPayload(event);
  if (!type || !data) return [];
  const fields = FEATURED_FIELDS_BY_TYPE[type];
  if (!fields) return [];
  return fields
    .map((field) => participantMainId(data[field]))
    .filter((id): id is string => id != null);
}
